import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const SocialNetworking = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Social Networking" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/business-process',
                            'text':'Business Process'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>Social Networking</h2>
                        
                        <h3>Stand Apart From Crowd</h3>
                        <p>Get the best social network development services for your business fully customized to your niche in line with technology standards.</p>
                        <h3>Adding A Social Dimension</h3>
                        <p>We incorpate technology mediated social interactions to our development practices, and techniques thereby adding a social dimension to customer interactions.</p>
                        <h3>Not Just Networking</h3>
                        <p>The network platforms we build doesn’t just involve user interactions and sharing of common interests but one can promote their brands, sell products, run campaigns, & so on</p>
                        <h3 className="text-center mt-5">Metrics Involved In Development</h3>
                        <img alt="" src={require('../../assets/images/services/social-networking.png')}  className="d-block m-auto mw-60" />
                        <h3 className="text-center mt-5">How We Do</h3>
                        <img alt="" src={require('../../assets/images/services/social-networking-2.png')}  className="d-block m-auto mw-50" />
                        <h3 className="text-center mt-5">Select Network That Suits Your Niche</h3>
                        <img alt="" src={require('../../assets/images/services/social-networking-3.png')} className="d-block m-auto mw-70" />
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default SocialNetworking;